/**
 * Get environment prefix for secureserver.net domains
 * Returns empty string for production, 'dev-', 'test-', etc for other environments
 *
 * @param {string} nodeEnv - The NODE_ENV value
 * @returns {string} The environment prefix (e.g., 'dev-', 'test-', '')
 */
function getEnvPrefix(nodeEnv) {
  const env = nodeEnv || 'production';

  if (env === 'production') {
    return '';
  }

  if (env === 'development' || env === 'dev' || env === 'local') {
    return 'dev-';
  }

  if (env === 'test') {
    return 'test-';
  }

  return '';
}

/**
 * Get storefront API URL with environment prefix
 * Returns https://www.<env->secureserver.net
 *
 * @param {string} nodeEnv - Optional NODE_ENV value (defaults to process.env.NODE_ENV or 'development')
 * @returns {string} The storefront API URL with prefix
 */
function getStorefrontUrl(nodeEnv) {
  // Try to use passed nodeEnv, then process.env.NODE_ENV, then default to 'development'
  let env = nodeEnv || process.env.NODE_ENV || 'production';
  const prefix = getEnvPrefix(env);
  return `https://www.${prefix}secureserver.net`;
}

module.exports = {
  getStorefrontUrl,
  getEnvPrefix
};
